import type { TextareaProps } from "@chakra-ui/react";
import { Textarea } from "@equidefi/ui/forms";
import type { FieldPath, FieldValues } from "react-hook-form";
import { useController, useFormContext } from "react-hook-form";

export type SmartTextareaProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<TextareaProps, "name"> & {
  name: TName;
  label?: string;
  helperText?: string;
  isRequired?: boolean;
};

function SmartTextarea<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, label, helperText, isRequired, ...textareaProps }: SmartTextareaProps<TFieldValues, TName>) {
  const { control } = useFormContext<TFieldValues>();
  const {
    field,
    fieldState: { error },
  } = useController<TFieldValues, TName>({
    name,
    control,
  });

  return (
    <Textarea
      {...field}
      label={label as string}
      isInvalid={!!error}
      isRequired={isRequired}
      helperText={helperText}
      error={error?.message}
      {...textareaProps}
    />
  );
}

export default SmartTextarea;
